export default {
    data: function() {
        return {
            defaultHandlers: {
                deleteItem: (items, idx) => {
                    items = JSON.parse(JSON.stringify(items.splice(idx, 1)))
                },
                discountItem: (items, idx) => {
                    alert('Modal de descuentos')
                },
                showWholesale: (items, idx) => {},
                showStockByWarehouse: (items, idx) => {
                    alert('Miodal stock otras bodegas')
                },
                priceReplace() {},
            },
        }
    },
    computed: {
        defaultActions: function() {
            return [
                {
                    name: 'delete',
                    icon: 'delete',
                    iconColor: 'red darken-2',
                    handler: this.defaultHandlers.deleteItem,
                    tooltip: 'eliminar',
                },
                {
                    name: 'discount',
                    icon: 'arrow_downward',
                    iconColor: 'orange darken-2',
                    handler: this.defaultHandlers.discountItem,
                    tooltip: 'descuento',
                },
                {
                    name: 'price_replace',
                    icon: 'compare_arrows',
                    iconColor: 'teal',
                    handler: this.defaultHandlers.priceReplace,
                    tooltip: 'reemplazo de precio',
                },
                {
                    name: 'show_wholesale',
                    icon: 'layers',
                    iconColor: 'blue darken-2',
                    handler: this.defaultHandlers.showWholesale,
                    tooltip: 'Ver precios pormayor',
                },
                {
                    name: 'show_stock_by_warehouse',
                    icon: 'storage',
                    iconColor: 'green darken-2',
                    handler: this.defaultHandlers.showStockByWarehouse,
                    tooltip: 'Ver stock en otras bodegas',
                },
            ]
        },
    },
}
